import React from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '../icons/Icon';
import { theme } from '../../styles/theme';
import { ChanceToMatch } from '../../types/loanType';
import { ChanceToMatchIndicator } from './ChanceToMatchIndicator';
import { InterestRateInput } from './InterestRateInput';
import styles from './LoanTypeSection.module.less';

interface CustomLoanCardProps {
  selected: boolean;
  customInterestRate: string;
  onCustomInterestRateChange: (rate: string | number) => void;
  onSelect: () => void;
  isPulsing: boolean;
  chanceToMatch: ChanceToMatch | null;
  minRate: number;
  maxRate: number;
}

export const CustomLoanCard: React.FC<CustomLoanCardProps> = ({
  selected,
  customInterestRate,
  onCustomInterestRateChange,
  onSelect,
  isPulsing,
  chanceToMatch,
  minRate,
  maxRate,
}) => {
  const intl = useIntl();

  const cardClassName = `${styles.loanTypeCard}${isPulsing ? ` ${styles.pulsing}` : ''}`;
  const checkboxClassName = `${styles.cardCheckbox}${selected ? ` ${styles.checked}` : ''}`;
  const checkmarkClassName = `${styles.checkmarkIcon}${selected ? ` ${styles.visible}` : ''}`;

  return (
    <div
      className={cardClassName}
      onClick={onSelect}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
    >
      <div className={styles.cardHeader}>
        <div className={checkboxClassName}>
          <span className={checkmarkClassName}>
            <Icon type="checkmark" color={theme.white} />
          </span>
        </div>
        <div className={styles.cardInfo}>
          <div className={styles.cardTitleRow}>
            <div className={styles.cardTitle}>
              {intl.formatMessage({ id: 'loanType.marketplace.title' })}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cardDescription}>
        {intl.formatMessage({ id: 'loanType.marketplace.description' })}
      </div>

      <InterestRateInput
        value={customInterestRate}
        onChange={onCustomInterestRateChange}
        minRate={minRate}
        maxRate={maxRate}
      />

      <div className={styles.cardFooter}>
        <ChanceToMatchIndicator chanceToMatch={chanceToMatch} />
      </div>
    </div>
  );
};
